import React from 'react'

// Dynamic theme https://ant.design/docs/react/customize-theme-variable
import 'antd/dist/antd.variable.min.css'
import './assets/main.css'

import { ConfigProvider } from 'antd'
import { useTheme } from './hooks/useTheme'

const ThemeProvider = ({ children }) => {
  useTheme()

  return <>{children}</>
}

const AntProvider = ({ children }) => (
  <ConfigProvider>
    <ThemeProvider>{children}</ThemeProvider>
  </ConfigProvider>
)

export default AntProvider

/**
 * import { connect } from 'react-redux'
 * import { getData, isLoaded, isLoading, loadThemeFormPublic } from './redux/actions/unrestricted/theme'
 *
class Container extends React.Component {
  componentDidMount () {
    this.props.loadThemeFormPublic()
  }

  render () {
    return (
      <>
        <ConfigProvider refixCls='custom'>{this.props.children}</ConfigProvider>
      </>
    )
  }
}

const MapStateToProps = (state) => {
  return {
    data: getData(state),
    loading: isLoading(state),
    loaded: isLoaded(state)
  }
}

const mapDispatchToProps = { loadThemeFormPublic }

export default connect(MapStateToProps, mapDispatchToProps)(Container)

// import "antd/dist/antd.css";
// https://okoriechinedusunday.medium.com/a-baby-guide-to-overriding-antdesign-theme-and-color-aa6df1f85e0
/* *
 *@import "./antd.less";
 * //@blue-6: #ff6e42;
 * @blue-6: #fea11d;
 * @blue-base: #fea11d;
 * @primary-color: #fea11d;
 * @link-color: #1890ff;
 * //@layout-header-background: #2b354f;
 * @layout-header-background: #333333;
 * //@layout-header-background: #2b292a;
 * //@layout-header-background: #343740;
 * //@layout-header-background: #1b1c21;
 * /
// import "./assets/custom-antd.css";
 */
